import * as Actions from './actions/Actions';
import uuid from 'uuid';
import {settings} from "../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
import {Input} from "../../../types/input";

export class SessionRequestProcessor {

    _settings: typeof settings;
    _store: Store<AlmeState> | null = null;

    constructor(passedSettings?: typeof settings)
    {
        this._settings = passedSettings ?? settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    isIgnored(input: Input): boolean
    {
        if (!this._settings.session) { 
            return false;
        }

        const ignoreMessageType = this._settings.session.ignoreMessageType as string[];
        const ignoreMessageSource = this._settings.session.ignoreMessageSource as string[];

        return ignoreMessageType.includes(input.messageType) || ignoreMessageSource.includes(input.messageSource as string);
    }

    process(input: Input): Input
    {
        const state = this._store?.getState();

        let id = state?.Conversation.SessionId ?? "";

        if (id?.trim().length === 0) {

            const customSid = state?.Conversation.CustomSessionId ?? "";

            id = (customSid?.trim().length === 0) ? uuid.v4() : customSid ?? "";
            const isActive = !this.isIgnored(input) || !!state?.Conversation.IsActiveSession;

            this._store?.dispatch(Actions.setSessionId(
                id,
                isActive
            ));
        }

        return { ...input, sessionId: id };
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/session/src/request-processor-session.ts